import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RangoSalarialPerfilState } from './rango-salarial-perfil.state';

export const selectRangoSalarialPerfilState =
  createFeatureSelector<RangoSalarialPerfilState>('rangoSalarialPerfil');

export const selectAllRangosSalariales = createSelector(
  selectRangoSalarialPerfilState,
  state => state.rangosSalariales
);

export const selectSelectedRangoSalarial = createSelector(
  selectRangoSalarialPerfilState,
  state => state.selectedRangoSalarial
);

export const selectRangoSalarialPerfilLoading = createSelector(
  selectRangoSalarialPerfilState,
  state => state.loading
);

export const selectRangoSalarialPerfilCreating = createSelector(
  selectRangoSalarialPerfilState,
  state => state.creating
);

export const selectRangoSalarialPerfilUpdating = createSelector(
  selectRangoSalarialPerfilState,
  state => state.updating
);

export const selectRangoSalarialPerfilError = createSelector(
  selectRangoSalarialPerfilState,
  state => state.error
);

// Selector para rangos salariales por perfil
export const selectRangosSalarialesByPerfil = (perfilId: number) =>
  createSelector(selectAllRangosSalariales, rangosSalariales =>
    rangosSalariales.filter(r => r.perfilId === perfilId)
  );

// Selector para rangos salariales por año
export const selectRangosSalarialesByAno = (ano: number) =>
  createSelector(selectAllRangosSalariales, rangosSalariales =>
    rangosSalariales.filter(r => r.ano === ano)
  );

// Selector para verificar si existe un rango salarial para un perfil y año específicos
export const selectRangoSalarialExists = (perfilId: number, ano: number) =>
  createSelector(selectAllRangosSalariales, rangosSalariales =>
    rangosSalariales.some(r => r.perfilId === perfilId && r.ano === ano)
  );
